import React, { PropsWithChildren } from 'react';
import { IResourceContext, ResourceProps } from './types';

export const ResourceContext = React.createContext<IResourceContext>({
  resources: []
});

export const ResourceProvider: React.FC<
  PropsWithChildren<{
    resources: ResourceProps[];
  }>
> = ({ children, resources }) => {
  const resourceValue = React.useMemo(() => {
    return resources ?? [];
  }, [resources]);

  return (
    <ResourceContext.Provider value={{resources:resourceValue}}>
      {children}
    </ResourceContext.Provider>
  );
};
